import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { PrimaryButton } from '@xingternal/malt-button';

import LockImage from './../../../Components/Illustrations/LockImage';
import PageviewTracker from './../../../Components/PageviewTracker/PageviewTracker';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import api from '../../../utils/api';

import Store from '../../../store';

import styles from './styles.css';
import messages from './messages';

const PasswordUpdateNeeded = ({ toLogin, email, history: { push } }) => {
  const [isLoading, setIsLoading] = useState(false);
  const context = useContext(Store);

  const handleClick = e => {
    e.preventDefault();
    setIsLoading(true);

    api
      .post('/recovery/password/reset_requests')
      .then(() => {
        context.dispatch({
          type: 'SET_USERNAME',
          payload: { username: email },
        });
        push('/recovery/password/confirm');
      })
      .catch(err => {
        console.error(err);

        setIsLoading(false);
        toLogin();
      });
  };

  return (
    <React.Fragment>
      <PageviewTracker pageName={'wbm/Welcome/login/account/password_reset'} />
      <LockImage />
      <CustomH>
        <FormattedMessage {...messages.passwordUpdateTitle} />
      </CustomH>
      <CustomP>
        <FormattedMessage {...messages.passwordUpdateSubTitle} />
      </CustomP>
      <CustomP>
        <FormattedMessage {...messages.passwordTooOldParagraph} />
      </CustomP>
      <PrimaryButton
        loading={isLoading}
        className={styles.wideButton}
        onClick={handleClick}
      >
        <FormattedMessage {...messages.passwordUpdateButtonText} />
      </PrimaryButton>
    </React.Fragment>
  );
};

export default withRouter(PasswordUpdateNeeded);
